import { put, fork, take, select, call } from 'redux-saga/effects';
import { takeFetch } from 'redux/helpers';
import * as serviceActions from '../../../services/actions';
import * as perojectSprintActions from '../../../configuration/project/editor/sprint/actions';
import * as fieldsetActions from '../fieldset/actions';
import * as actions from './actions';
import { reloadBacklog } from '../../../../helpers';

function* getTemplate() {
  const { success } = yield takeFetch(serviceActions.api.configuration.sprint.GET_TEMPLATE);
  if (success) {
    yield put(fieldsetActions.init.begin({ sprint: success.data }));
    yield put(actions.open.end({ template: success.data }));
  }
}

function* updateSprint() {
  const { success } = yield takeFetch(serviceActions.api.configuration.sprint.UPSERT);
  if (success) {
    yield put(actions.create.end());
      const isBacklog = yield call(reloadBacklog);
      if(!isBacklog) {
          yield put(perojectSprintActions.refresh());
      }
    ttb.Notifications.ShowSaveSuccessMessage('Project Configuration', 'All the changes have been saved');
  } else {
    ttb.Notifications.ShowErrorMessage('Project Configuration', 'The changes have not been saved');
  }
}

function* create() {
  while (true) {
    const fields = yield take(actions.CREATE.BEGIN);
    yield put(serviceActions.api.configuration.sprint.upsert.request(fields));
    yield fork(updateSprint);
  }
}

function* loadPopupData({ projectId, sprintId, teamId })
{
  yield put(fieldsetActions.reset());
  const { template } = yield select(state => state.configuration.sprint.creator);
  yield put(serviceActions.api.configuration.sprint.getTemplate.request({ projectId, sprintId, teamId }));
  yield fork(getTemplate);
  if(template)
  {
    yield put(fieldsetActions.init.begin({ sprint: template }));
    yield put(actions.open.end({ template }));
  }
}

function* open() {
  while (true) {

    const { projectId, sprintId, teamId } = yield take(actions.OPEN.BEGIN);
    const { template } = yield select(state => state.configuration.sprint.creator);
    if (true) {
      yield fork(loadPopupData,{projectId, sprintId, teamId});

    }  else {
        yield put(fieldsetActions.init.begin({ sprint: template }));
        yield put(actions.open.end({ template }));
    }
      $('sprint-creator-popup > .modal').modal('show');
  }
}

function* reloadPopup() {
  while (true) {
    yield take(actions.SET_TEAM)
    const { template, selectedTeam } = yield select(state => state.configuration.sprint.creator);
   
     yield fork(loadPopupData,  { teamId: selectedTeam.id, projectId: template.projectId } );
  }
}

function* close() {
  while (true) {
    yield take(actions.CLOSE);
    $('sprint-creator-popup > .modal').modal('hide');
  }
}

export default function* creator() {
  yield fork(create);
  yield fork(open);
  yield fork(reloadPopup);
  yield fork(close);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/sprint/creator/saga.js